import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Image } from '../../interfaces/image';
import Glide, { Controls, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm';

@Component({
  selector: 'app-slideshow',
  templateUrl: './slideshow.component.html',
  styleUrls: ['./slideshow.component.scss']
})
export class SlideshowComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() images: Image[];
  glider;
  activeImageIndex = 1;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // Init slideshow
    if (this.images && this.images.length) {
      this.glider = new Glide('.glide').mount({ Controls, Breakpoints, Swipe });

      this.glider.on('run', res => {
        if (res && res.direction === '>') {
          this.activeImageIndex = this.activeImageIndex === this.images.length ? 1 : this.activeImageIndex + 1;
        } else if (res && res.direction === '<') {
          this.activeImageIndex = this.activeImageIndex === 1 ? this.images.length : this.activeImageIndex - 1;
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.glider) {
      this.glider.destroy();
    }
  }
}
